module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-pkm-torjun",
  subdomain: "pkmtorjun",
};
